// Date/number formatting — ported from D:\campaigning-system\src\lib\format.ts.
// No locale / Date.now dependence (deterministic).
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function formatDate(iso) {
  const [y, m, d] = String(iso).split('-').map(Number);
  if (!y || !m || !d) return iso;
  return `${d} ${MONTHS[m - 1]} ${y}`;
}

/**
 * '2026-09-07' or a full ISO timestamp ('2026-09-07T08:10:13.749Z') -> '7 Sep'.
 * The timestamp form matters: API rows carry full timestamps, and the old date-only
 * parse silently returned the raw string for them.
 */
export function formatShortDate(iso) {
  if (!iso) return '—';
  const [, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!m || !d) return String(iso);
  return `${d} ${MONTHS[m - 1]}`;
}

/** A full ISO timestamp -> '11 Sep 2026, 7:44 pm' in the viewer's local time; a bare date stays a date. */
export function formatDateTime(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  if (String(iso).length <= 10) return formatDate(iso);
  const h = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${h % 12 || 12}:${minutes} ${h < 12 ? 'am' : 'pm'}`;
}

export function formatNumber(n) {
  return Number(n).toLocaleString('en-US');
}

export function formatCompact(n) {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
  if (n >= 1000) return `${(n / 1000).toFixed(n % 1000 === 0 ? 0 : 1)}k`;
  return `${n}`;
}
